import ChirpyWeb from '../../assets/icons/ChirpyWebLogoFull.svg'

const LogoContainer = ({src}) => <div className="logo-container mt-5">
    <img src={src || ChirpyWeb} alt="logo"/>
</div>


export default LogoContainer;